export default __webpack_public_path__ + "images/0109c92633e0f08f845890bfbc1e0b25-apple-pay.svg";